<template>
  <vs-row>
    <vs-col>
      <div v-if="!loadingSections && venueSections && venueSections.length > 0">
        <vs-select
          label="Section"
          class="w-full"
          v-model="selectedVenueSection"
          @change="$emit('venue-section-selected', selectedVenueSection)"
          :disabled="disableComponent"
        >
          <vs-select-item
            v-for="section in venueSections"
            :key="section.venueSectionId.id"
            :value="section"
            :text="section.name"
          />
        </vs-select>
      </div>
      <div
        class="grid place-content-center h-full"
        v-if="!loadingSections && venueSections && venueSections.length == 0"
      >
        <div class="text-gray text-sm">
          <label class="vs-input--label">Section</label>
          <div>No available sections for this date, time and venue</div>
        </div>
      </div>
      <div v-if="loadingSections">
        <span class="flex h-4 w-4 mt-2">
          <span
            class="
              animate-ping
              absolute
              inline-flex
              h-4
              w-4
              rounded-full
              bg-primary
              opacity-75
            "
          ></span>
          <span
            class="relative inline-flex rounded-full h-4 w-4 bg-primary"
          ></span>
        </span>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  components: {},
  props: {
    venueSectionId: Object,
    venueSections: Array,
    loadingSections: Boolean,
    disableComponent: Boolean,
  },
  data() {
    return {
      selectedVenueSection: undefined,
    };
  },
  async mounted() {},
  computed: {},
  watch: {
    venueSectionId() {
      this.setSeletedVenueSection();
    },
    venueSections() {
      this.setSeletedVenueSection();
    },
  },
  methods: {
    setSeletedVenueSection() {
      if (this.venueSections && this.venueSectionId) {
        let section = this.venueSections.find((v) => {
          return v.venueSectionId.id === this.venueSectionId.id;
        });
        this.selectedVenueSection = section ? section : null;
      } else {
        this.selectedVenueSection = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
